'use client';

import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_LOCALE } from '@/modules/localization';

export const useNavigation = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const { push, replace } = useRouter();

  const generateLink = useCallback(
    (link: string) =>
      language === DEFAULT_LOCALE
        ? link
        : `/${language}${link === '/' ? '' : link}`,
    [language]
  );

  const navigate = useCallback(
    (link: string, scrollToTop = false, replaceUrl = false) => {
      const method = replaceUrl ? replace : push;
      method(generateLink(link), { scroll: scrollToTop });
    },
    [generateLink, push, replace]
  );

  return { generateLink, navigate };
};
